import React, { useState } from "react";
import { Link, NavLink } from "react-router-dom";
import { Menu, X } from "lucide-react";

export function PublicHeader() {
    const [open, setOpen] = useState(false);
    const close = () => setOpen(false);

    return (
        <header className="border-b border-[#e4e4e7] bg-white sticky top-0 z-40" data-testid="public-header">
            <div className="max-w-7xl mx-auto px-4 md:px-10 h-16 md:h-20 flex items-center justify-between gap-4">
                <Link to="/" className="font-display text-2xl md:text-3xl text-[#0d1628] tracking-tight" data-testid="logo-link">
                    IHTP
                </Link>

                <nav className="hidden md:flex items-center gap-10">
                    <NavLink to="/planos" className="link-underline text-sm text-[#0d1628]" data-testid="nav-pricing">
                        Planos
                    </NavLink>
                    <a href="https://ihavethepower.net" target="_blank" rel="noreferrer" className="link-underline text-sm text-[#0d1628]" data-testid="nav-external">
                        ihavethepower.net
                    </a>
                </nav>

                <div className="hidden md:flex items-center gap-3">
                    <Link to="/login" className="btn-ghost" data-testid="nav-login">Entrar</Link>
                    <Link to="/register" className="btn-primary hidden sm:inline-flex" data-testid="nav-register">Registar empresa</Link>
                </div>

                <button
                    className="md:hidden p-2 -mr-2 text-[#0d1628]"
                    onClick={() => setOpen(!open)}
                    data-testid="public-mobile-toggle"
                    aria-label="Menu"
                >
                    {open ? <X size={22} /> : <Menu size={22} />}
                </button>
            </div>

            {/* Mobile menu */}
            {open && (
                <div className="md:hidden border-t border-[#e4e4e7] bg-white" data-testid="public-mobile-menu">
                    <nav className="flex flex-col">
                        <NavLink to="/planos" onClick={close} className="px-6 py-4 text-sm text-[#0d1628] border-b border-[#e4e4e7] hover:bg-[#f4f4f5]">Planos</NavLink>
                        <a href="https://ihavethepower.net" target="_blank" rel="noreferrer" onClick={close} className="px-6 py-4 text-sm text-[#0d1628] border-b border-[#e4e4e7] hover:bg-[#f4f4f5]">ihavethepower.net</a>
                        <Link to="/login" onClick={close} className="px-6 py-4 text-sm text-[#0d1628] border-b border-[#e4e4e7] hover:bg-[#f4f4f5]" data-testid="mobile-login">Entrar</Link>
                        <Link to="/register" onClick={close} className="px-6 py-4 text-sm font-medium text-white bg-[#0d1628] hover:bg-[#1a2c4e]" data-testid="mobile-register">Registar empresa</Link>
                    </nav>
                </div>
            )}
        </header>
    );
}

export function PublicFooter() {
    return (
        <footer className="border-t border-[#e4e4e7] bg-white mt-16 md:mt-24" data-testid="public-footer">
            <div className="max-w-7xl mx-auto px-6 md:px-10 py-12 md:py-16 grid md:grid-cols-3 gap-10 md:gap-12">
                <div>
                    <div className="font-display text-3xl text-[#0d1628]">IHTP</div>
                    <p className="text-sm text-[#52525b] mt-4 leading-relaxed max-w-xs">
                        I Have The Power. Metodologia de gestão de projetos de felicidade para organizações que querem transformar cultura e resultados.
                    </p>
                </div>
                <div>
                    <div className="label-caps">Plataforma</div>
                    <ul className="mt-6 space-y-3 text-sm">
                        <li><Link to="/planos" className="link-underline">Planos</Link></li>
                        <li><Link to="/login" className="link-underline">Área reservada</Link></li>
                        <li><Link to="/register" className="link-underline">Registar empresa</Link></li>
                    </ul>
                </div>
                <div>
                    <div className="label-caps">Contacto</div>
                    <ul className="mt-6 space-y-3 text-sm">
                        <li><a href="https://ihavethepower.net" target="_blank" rel="noreferrer" className="link-underline">ihavethepower.net</a></li>
                    </ul>
                </div>
            </div>
            <div className="border-t border-[#e4e4e7] text-xs text-[#52525b] py-6 text-center px-4">
                © {new Date().getFullYear()} IHTP — I Have The Power. Todos os direitos reservados.
            </div>
        </footer>
    );
}

export default function MarketingLayout({ children }) {
    return (
        <div className="min-h-screen bg-white">
            <PublicHeader />
            <main>{children}</main>
            <PublicFooter />
        </div>
    );
}
